export default "__VITE_ASSET__CJbaFzu2__"